<template>
  <div class="fc-snackbar__wrapper">
    <div class="fc-snackbar">
      <h1 class="fc-snackbar__title">{{ title }}</h1>
      <div class="fc-snackbar__content" v-html="subTitle"></div>
      <div class="fc-snackbar__button">
        <button type="button" class="btn-text" @click="close">{{ closeButtonText }}</button>
        <button type="button" class="btn-confirm" @click="complete">{{ buttonText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'snackbar',
  props: {
    title: String,
    subTitle: String,
    closeButtonText: String,
    buttonText: String,
  },
  methods: {
    close() {
      this.$emit('close');
    },
    complete() {
      this.$emit('complete');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@fastcampus/styles/style.scss';
.fc-snackbar {
  box-sizing: border-box;
  padding: 2.4rem 2rem;

  background: #171717;

  animation: snackbar 0.3s ease-in forwards;
  &__wrapper {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 1;

    width: 100%;
  }
  &__title {
    margin-bottom: 0.8rem;

    font-weight: bold;
    font-style: normal;
    font-size: 1.6rem;
    color: #fff;
    line-height: 2.4rem;
  }
  &__content {
    margin-bottom: 1.6rem;

    font-size: 1.4rem;
    color: #fff;
    line-height: 2.2rem;
  }
  &__button {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    .btn-confirm {
      flex-grow: 2;

      padding: 1.2rem;
      border-radius: 0.4rem;

      background-color: #ed234b;

      font-weight: bold;
      font-size: 1.6rem;
      color: #fff;
      line-height: 2.4rem;
      text-align: center;
    }
    .btn-text {
      flex-grow: 1;

      margin-right: 1.2rem;
      padding: 1.2rem;
      border-radius: 0.4rem;

      background: #171717;

      font-weight: bold;
      font-size: 1.6rem;
      color: #fff;
      line-height: 2.4rem;
    }
  }

  @keyframes snackbar {
    from {
      opacity: 0;

      transform: translateY(60px);
    }
    to {
      opacity: 1;

      transform: translateY(0);
    }
  }
  @include mq(large) {
    max-width: 36rem;
    padding: 1.6rem 2.4rem;
    border-radius: 0.4rem;
    &__wrapper {
      position: fixed;
      right: 6.4rem;
      bottom: 3.2rem;
      z-index: 1;

      width: auto;
    }
    &__title {
      &::before {
        font-size: 1.4rem;
        line-height: 2.2rem;
      }
    }
    &__content {
      &::before {
        white-space: pre;
      }
    }
    &__button {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      .btn-confirm {
        flex: none;

        padding: 0.5rem 1.6rem;
        border-radius: 0.4rem;

        background-color: #ed234b;

        font-weight: normal;
        font-size: 1.4rem;
        color: #fff;
        line-height: 2.2rem;
      }
      .btn-text {
        flex: none;

        margin-right: 1.2rem;
        padding: 0.5rem 1.6rem;
        border-radius: 0.4rem;

        background: #2e2e2e;

        font-weight: normal;
        font-size: 1.4rem;
        color: #fff;
        line-height: 2.2rem;
      }
    }
  }
}
</style>
